import type { Page } from '../../types';

const approvalQ3: Page[] = [
  {
    pageType: 'question',
    title: 'Approval',
    name: 'approval-q3',
    hidePageTitle: true,
    disabled: [
      {
        field: 'pending_approval_quarter',
        condition: 'notEquals',
        value: 'Q3',
      },
    ],
    questions: [
      {
        questionType: 'reportPeriod',
        title: 'Period of Report',
        name: 'approval-report-period-q3',
        readOnly: true,
        autoFill: {
          keys: [],
          field: 'report-period',
        },
      },
      {
        questionType: 'textarea',
        title:
          'Taking into account the summary the individual has submitted, along with any feedback received, please provide your assessment of their performance. Please provide a clear, concise summary, which directly relates to the minimum standards and business objectives. In making this Quarter 3 assessment, it is important to acknowledge and set aside any personal bias, conscious and unconscious, to ensure an objective appraisal of the person you are reporting on',
        name: 'talent-career-managers-assessment-q3',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'Were the minimum standards met?',
        name: 'talent-career-minimum-standards-met-q3',
        hintOption: 'Select an option',
        options: [
          'Yes',
          {
            option: 'No',
            questions: [
              {
                questionType: 'textarea',
                title: 'Comments',
                name: 'talent-career-minimum-standards-met-comments-q3',
                rules: { required: true },
              },
            ],
          },
        ],
        rules: { required: true },
      },
      {
        questionType: 'select',
        title: 'Indicative Quater 3 Performance Marking',
        name: 'talent-career-indicative-performance-q3',
        hint: 'Please confirm the indicative performance rating you are putting forward for the individual.  Markings should not be communicated to individuals until formal sign-off has been completed and communicated.',
        hintOption: 'Select an option',
        options: ['Exceeding','High Performing','Achieving','Partially Met'], 
        rules: {
          required: true,
        },
      },
      {
        questionType: 'select',
        title:
          'Is the individual being considered for and currently applying for any development programme?',
        name: 'talent-career-applying-development-programme-q3',
        hintOption: 'Select an option',
        options: [
          {
            option: 'Yes',
            questions: [
              {
                questionType: 'textInput',
                title: 'Please provide details',
                name: 'talent-career-applying-development-programme-details-q3',
                rules: { required: true },
              },
            ],
          },
          'No',
        ],
        rules: { required: true },
      },
      {
        questionType: 'radio',
        title:
          'In your view, is the individual likely to move on from their current role in the next 12 months',
        hint: 'This could include new role in the department, new role across Government or private sector',
        name: 'talent-career-likely-move--12-months-q3',
        hintOption: 'Select an option',
        options: [
          {
            option: 'Yes',
            questions: [
              {
                questionType: 'textarea',
                title: 'Please provide further information',
                name: 'talent-career-likely-move-12-months-detail-q3',
                rules: { required: true },
              },
            ],
          },
          'No',
        ],
        rules: { required: true },
      },
      {
        questionType: 'checkbox',
        title:
          'In making this Quarter 3 assessment, it is important to acknowledge and set aside any personal bias, conscious and unconscious, to ensure an objective appraisal of the person you are reporting on.',
        name: 'talent-career-manager-decleration-q3',
        options: ['I confirm acknowledgement of this statement'],
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default approvalQ3;
